/* eslint-disable import/prefer-default-export */
import { FILTER_ITEM_ID_KEY } from "../ReportsAggsFilterSettings/constants";

const getId = (filterKey, item) => {
  const idKey = FILTER_ITEM_ID_KEY[filterKey];
  return idKey ? item[idKey] : item;
}

const createSelectFilterObj = (filterKey, item) => {
  return { filterKey, item }
};

export const addSelectedFilter = (
  filterKey,
  item,
  {
    selectedFiltersArr: paramSelectedFiltersArr = [],
    selectedFiltersArrByFilterKey: paramSelectedFiltersArrByFilterKey = {},
    selectedFiltersMap: paramSelectedFiltersMap = {}
  } = {}) => { 
  const selectedFiltersArr = [...paramSelectedFiltersArr];
  const selectedFiltersArrByFilterKey = { ...paramSelectedFiltersArrByFilterKey };
  const selectedFiltersMap = { ...paramSelectedFiltersMap };
  const newFilter = createSelectFilterObj(filterKey, item);

  selectedFiltersArr.push(newFilter);

  selectedFiltersArrByFilterKey[filterKey] = [...(selectedFiltersArrByFilterKey[filterKey] || [])];
  selectedFiltersArrByFilterKey[filterKey].push(newFilter);


  selectedFiltersMap[filterKey] = {
    ...(selectedFiltersMap[filterKey] || {}),
    [getId(filterKey, item)]: newFilter
  }

  return { selectedFiltersArr, selectedFiltersArrByFilterKey, selectedFiltersMap };
}

export const removeSelectedFilter = (
  filterKey,
  item,
  {
    selectedFiltersArr: paramSelectedFiltersArr = [],
    selectedFiltersArrByFilterKey: paramSelectedFiltersArrByFilterKey = {},
    selectedFiltersMap: paramSelectedFiltersMap = {}
  } = {}
) => { 

  const selectedFiltersArr = paramSelectedFiltersArr
    .filter((fObj) => fObj.filterKey !== filterKey || getId(fObj.filterKey, fObj.item) !== getId(filterKey, item));

  const selectedFiltersArrByFilterKey = { ...paramSelectedFiltersArrByFilterKey };
  selectedFiltersArrByFilterKey[filterKey] = selectedFiltersArrByFilterKey[filterKey]
    .filter((fObj) => fObj.filterKey !== filterKey || getId(fObj.filterKey, fObj.item) !== getId(filterKey, item));
  
  const selectedFiltersMap = { ...(paramSelectedFiltersMap || {}) };
  selectedFiltersMap[filterKey] = { ...(selectedFiltersMap[filterKey]) };
  delete selectedFiltersMap[filterKey][getId(filterKey, item)];
  if (Object.keys(selectedFiltersMap[filterKey]).length === 0) { 
    delete selectedFiltersMap[filterKey];
  }

  return { selectedFiltersArr, selectedFiltersArrByFilterKey, selectedFiltersMap };
}

export const computeIsFilterItemSelected = (filterKey, item, selectedFiltersMap) => { 
  const id = getId(filterKey, item)
  const map = selectedFiltersMap[filterKey] || [];
  return !!map[id];
}

export default {
  getFilterItemId: getId,
  addSelectedFilter,
  removeSelectedFilter,

  computeIsFilterItemSelected
}